import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons'
import { SET_MAP_STYLE, MAP_STYLE_LOADING } from '../state/uiActions';
//import { SET_VIEWPORT_LAYER_VISIBILITY} from '../state/viewportAction.js' ;

/**  */
export default function MapStyleConfigRow(props)  {

  const dispatch = useDispatch(); 
  const mapStyle = useSelector((state) => state.ui.mapStyle)

  const handleOptionChange = changeEvent => {
    var map = props.map 
    //console.log('MapStyleConfigRow: setStyle, ', changeEvent.target.value);
    dispatch({ type: SET_MAP_STYLE, mapStyle: changeEvent.target.value})
    // map.setStyle( changeEvent.target.value, {diff: false}) 

    // // HACK: setStyle is async, have to subscribe for an event 
    // const afterStyleEvent = () =>  { 
    //   dispatch({ type: MAP_STYLE_LOADED, style: changeEvent.target.value})
    //   map.off('styledata', afterStyleEvent )
    //   console.log("styledata event: ", props.map.getStyle().layers);
    // }
    // map.on('styledata', afterStyleEvent)
  }

  var toggle = ( <FontAwesomeIcon icon={faToggleOff} />  );

  return (
    <div>
      <div>
      <button type="button" className="menu-item-row btn btn-outline-secondary btn-sm text-left form-check">
        <label>
          <input className="form-check-input" type="radio" name="mo-outdoor" id="mo-outdoor-minimal"
                 value='mapbox://styles/sidlo/cktu0coif0kwn17o8nbfrusbm'
                 checked={mapStyle==='mapbox://styles/sidlo/cktu0coif0kwn17o8nbfrusbm'}
                 onChange={handleOptionChange}/>
          &nbsp; &nbsp; egyszerű turistatérkép
        </label>
      </button>
      </div>
      <div>
      <button type="button" className="menu-item-row btn btn-outline-secondary btn-sm text-left form-check">
        <label>
          <input className="form-check-input" type="radio" name="mo-outdoor" id="mo-outdoor"
                 value='mapbox://styles/sidlo/ckujslsa6bw8h17mwd0oe1q15'
                 checked={mapStyle==='mapbox://styles/sidlo/ckujslsa6bw8h17mwd0oe1q15'}
                 onChange={handleOptionChange}/>
          &nbsp; &nbsp; turistatérkép
        </label>
      </button>
      </div>
      <div>
      <button type="button" className="menu-item-row btn btn-outline-secondary btn-sm text-left form-check">
        <label>
          <input className="form-check-input" type="radio" name="mo-satellite" id="mo-satellite" 
                //value='mapbox://styles/mapbox/satellite-v9'
                value='mapbox://styles/sidlo/cljmwljmn00ch01qwff8gcjyr'
                checked={mapStyle==='mapbox://styles/sidlo/cljmwljmn00ch01qwff8gcjyr'} 
                onChange={handleOptionChange}/>
            &nbsp; &nbsp; műholdas térkép
        </label>
      </button>
      </div>
    </div>
  );

}
